import React from 'react';
import { HEADING_TEXT_2, MAINTENANCE_IMAGE } from '../../../utilities/generatedClasses';

const RecommendationUnsupportedDevice = () => (
  <div className="recommendations-empty-data" style={{ height: '320px' }}>
    <div style={{ width: '269px', height: '100vh' }} className={MAINTENANCE_IMAGE} />
    <label className={HEADING_TEXT_2} style={{ marginTop: '24px', textAlign: 'center' }}>
      Recommendations can't be show on this device
    </label>
  </div>
);

export default RecommendationUnsupportedDevice;
